import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  HomeIcon,
  CalendarIcon,
  UsersIcon,
  ShoppingBagIcon,
  BuildingStorefrontIcon,
  CreditCardIcon,
  BellIcon,
  ChartBarIcon,
  PhotoIcon,
  CogIcon,
  UserCircleIcon,
  HeartIcon,
} from '@heroicons/react/24/outline';

const navigation = [
  { name: 'Dashboard', href: '/', icon: HomeIcon },
  { name: 'Bookings', href: '/bookings', icon: CalendarIcon },
  { name: 'Profile', href: '/profile', icon: UserCircleIcon },
  { name: 'Favorites', href: '/favorites', icon: HeartIcon },
  { name: 'Business Profile', href: '/business/profile', icon: BuildingStorefrontIcon },
  { name: 'Staff', href: '/staff', icon: UsersIcon },
  { name: 'Services', href: '/services', icon: ShoppingBagIcon },
  { name: 'Portfolio', href: '/business/portfolio', icon: PhotoIcon },
  { name: 'Subscriptions', href: '/subscriptions', icon: CreditCardIcon },
  { name: 'Notifications', href: '/notifications', icon: BellIcon },
  { name: 'Analytics', href: '/analytics', icon: ChartBarIcon },
  { name: 'Settings', href: '/settings', icon: CogIcon },
];

const Sidebar = () => {
  const { isBusinessOwner, isAdmin, isStaff, isCustomer } = useAuth();

  // Filter navigation based on role
  const filteredNav = navigation.filter(item => {
    if (item.name === 'Business Profile' && !isBusinessOwner) return false;
    if (item.name === 'Favorites' && !isCustomer) return false;
    if (item.name === 'Staff' && !isBusinessOwner && !isAdmin) return false;
    if (item.name === 'Services' && !isBusinessOwner && !isAdmin && !isStaff) return false;
    if (item.name === 'Portfolio' && !isBusinessOwner && !isAdmin) return false;
    if (item.name === 'Subscriptions' && !isBusinessOwner && !isAdmin) return false;
    if (item.name === 'Analytics' && !isBusinessOwner && !isAdmin) return false;
    return true;
  });

  return (
    <div className="w-64 bg-white shadow-lg">
      <div className="flex items-center justify-center h-16 border-b">
        <h1 className="text-2xl font-bold text-primary-600">BookFlow</h1>
      </div>
      <nav className="mt-6">
        {filteredNav.map((item) => (
          <NavLink
            key={item.name}
            to={item.href}
            className={({ isActive }) =>
              `flex items-center px-6 py-3 text-gray-700 hover:bg-gray-100 transition-colors ${
                isActive ? 'bg-primary-50 text-primary-600 border-r-4 border-primary-600' : ''
              }`
            }
          >
            <item.icon className="h-5 w-5 mr-3" />
            {item.name}
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;
